/**
 * Ilustrações dos atalhos de fluxo guiado — a arte dos cards do handoff
 * "GuidedFlowCards" (`guided_flows` no chat + a home do web-chat), tirada do
 * catálogo de renders do DS (`SERVICE_ART`).
 */

import { SERVICE_ART } from '../service_art/service_art.js';

/**
 * The services a shortcut can lead to — one illustration per key. Closed on
 * purpose and kept structural: the kit never imports the genui-kit wire, so the
 * genui-kit proves its `GuidedFlow` and this union stay equal in a type test —
 * a new service breaks the typecheck before it reaches a card without art.
 */
export type GuidedFlowKey = 'flight' | 'hotel' | 'rental' | 'bus' | 'mobility';

/**
 * Peso óptico por serviço. Os renders não vêm com o mesmo enquadramento: o
 * ônibus ocupa quase toda a moldura enquanto avião/cama/carro respiram, então
 * ele entra menor para os quatro pesarem igual na fileira. Correção de
 * apresentação — a arte não é reexportada aqui.
 */
const SCALE: Partial<Record<GuidedFlowKey, string>> = { bus: '72%' };

/**
 * A ilustração de UM atalho. Decorativa (`alt=""`): quem nomeia o card é o
 * rótulo dentro do próprio botão, então a imagem não repete o nome pro leitor
 * de tela.
 */
export function FlowIllustration({ flow }: { readonly flow: GuidedFlowKey }) {
  return (
    <img
      className="gfc-illo"
      src={SERVICE_ART[flow]}
      alt=""
      draggable={false}
      style={SCALE[flow] ? { width: SCALE[flow], height: SCALE[flow] } : undefined}
    />
  );
}
